import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAIL_PATTERN } from '../utils/mail-pattern';

export class PersonalDataForm extends FormGroup<{
  name: FormControl<string>;
  surname: FormControl<string>;
  email: FormControl<string>;
}> {
  constructor() {
    super({
      name: new FormControl<string>(null, [
        Validators.pattern('^[ A-Za-z0-9\\-,.\\u00c0-\\u02c0]+$'),
        Validators.maxLength(100)
      ]),
      surname: new FormControl<string>(null, [
        Validators.required,
        Validators.pattern('^[ A-Za-z0-9\\-,.\\u00c0-\\u02c0]+$'),
        Validators.maxLength(100)
      ]),
      email: new FormControl<string>(null, [Validators.required, Validators.pattern(MAIL_PATTERN)])
    });
  }

  get name() {
    return this.get('name') as FormControl<string>;
  }

  get surname() {
    return this.get('surname') as FormControl<string>;
  }

  get email() {
    return this.get('email') as FormControl<string>;
  }
}
